import React, { useRef, useState } from 'react'
import DrawingCanvas from './drawing-canvas';
import { SignatureTranslations } from "./translations";

function DigitalSignatureComponent({ onData, onClose, translations }: { onData: (data: string | undefined) => void, onClose: () => void, translations: SignatureTranslations }) {
    const [isValidSignature, setIsValidSignature] = useState(false);

    const canvasCallbackRef = useRef<{ getDataURL: () => string | undefined; clearDrawing: () => void; }>();

    const onStartDrawing = () => {
        setIsValidSignature(true)
    }

    const onClearDrawing = () => {
        setIsValidSignature(false)
    }

    const next = () => {
        const data = canvasCallbackRef.current?.getDataURL();
        onData(data)
    }
    const cancel = () => onClose()

    return (
        <div className="modal-size-normal d-flex flex-column justify-content-between border border-primary animated slideInUp h-100" style={{ background: "white" }}>
            <div className="px-3 pt-3 h-100 d-flex flex-column">
                <DrawingCanvas
                    onStartDrawing={onStartDrawing}
                    onClearDrawing={onClearDrawing}
                    onGetImageCallback={(callbacks) => canvasCallbackRef.current = callbacks}
                    placeholder={translations.signaturePlaceholder}>
                </DrawingCanvas>
            </div>
            <div>
                <div className="p-3">
                    <small>{translations.thisSignatureIsLegitimate}</small>
                </div>

                <div className="border-top">
                    <div className="d-flex flex-column flex-end flex-md-start flex-md-row-reverse p-3">
                        <button type="button" className="btn btn-primary m-1" disabled={!isValidSignature} onClick={next}>
                            {translations.signAndConfirm}
                        </button>

                        <button type="button" className="btn border border-primary border-0 m-1" onClick={cancel}>
                            {translations.cancel}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DigitalSignatureComponent